import { render, staticRenderFns } from "./Vuetable.vue?vue&type=template&id=30e8531e&scoped=true"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"
import style0 from "./Vuetable.vue?vue&type=style&index=0&id=30e8531e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8531e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e8531e')) {
      api.createRecord('30e8531e', component.options)
    } else {
      api.reload('30e8531e', component.options)
    }
    module.hot.accept("./Vuetable.vue?vue&type=template&id=30e8531e&scoped=true", function () {
      api.rerender('30e8531e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-datatable/Vuetable.vue"
export default component.exports